import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdminSharedModule } from '@features/admin/@shared/@shared.module';
import { SharedModule } from '@features/batches/@shared/shared.module';
import { SiteCommonModule } from '@widgets/site-common/site-common.module';
import { AcceptInviteComponent } from './accept-invite/accept-invite.component';
import { CompanyInformationComponent } from './company/company-information/company-information.component';
import { ContactInfoComponent } from './company/contact-info/contact-info.component';
import { ReceivingSiteInfoComponent } from './company/receiving-site-info/receiving-site-info.component';
import { RegistrationComponent } from './company/registration.component';
import { SourceSiteInfoComponent } from './company/source-site-info/source-site-info.component';
import { RegistrationCompleteComponent } from './modals/registration-complete/registration-complete.component';
import { BusinessInfoComponent } from './qp/business-info/business-info.component';
import { QpPersonalInfoComponent } from './qp/qp-personal-info/qp-personal-info.component';
import { QpRegistrationComponent } from './qp/qp-registration.component';
import { RegisterBusinessTypeComponent } from './register-business-type/register-business-type.component';
import { RegistrationRoutingModule } from './registration-routing.module';
import { TermsComponent } from './terms/terms.component';

@NgModule({
  declarations: [
    RegisterBusinessTypeComponent,
    CompanyInformationComponent,
    SourceSiteInfoComponent,
    ReceivingSiteInfoComponent,
    ContactInfoComponent,
    RegistrationComponent,
    RegistrationCompleteComponent,
    QpRegistrationComponent,
    BusinessInfoComponent,
    QpPersonalInfoComponent,
    AcceptInviteComponent,
    TermsComponent
  ],
  imports: [CommonModule, RegistrationRoutingModule, SiteCommonModule, SharedModule, AdminSharedModule]
})
export class RegistrationModule {}
